import type { DigitalCard } from '../types/card'

export function cleanPhone(value = '') {
  return value.replace(/[^+\d]/g, '')
}

export function fullPhone(card: DigitalCard) {
  const number = cleanPhone(card.phone_number)
  const country = cleanPhone(card.country_code)
  return number.startsWith('+') ? number : `${country}${number}`
}

export function safeExternalUrl(value?: string | null) {
  if (!value) return null
  try {
    const withProtocol = /^https?:\/\//i.test(value) ? value : `https://${value}`
    const parsed = new URL(withProtocol)
    return ['http:', 'https:'].includes(parsed.protocol) ? parsed.toString() : null
  } catch {
    return null
  }
}

function escapeVCard(value?: string | null) {
  return (value ?? '').replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;')
}

export function downloadVCard(card: DigitalCard) {
  const lines = [
    'BEGIN:VCARD',
    'VERSION:3.0',
    `FN:${escapeVCard(card.name)}`,
    `N:${escapeVCard(card.name)};;;;`,
    card.company ? `ORG:${escapeVCard(card.company)}` : '',
    card.job_title || card.profession ? `TITLE:${escapeVCard(card.job_title || card.profession)}` : '',
    card.email ? `EMAIL;TYPE=INTERNET,WORK:${escapeVCard(card.email)}` : '',
    card.alternate_email ? `EMAIL;TYPE=INTERNET,HOME:${escapeVCard(card.alternate_email)}` : '',
    fullPhone(card) ? `TEL;TYPE=CELL:${fullPhone(card)}` : '',
    card.work_phone ? `TEL;TYPE=WORK:${cleanPhone(card.work_phone)}` : '',
    card.full_address ? `ADR;TYPE=WORK:;;${escapeVCard(card.full_address)};;;;` : '',
    card.website_url ? `URL:${safeExternalUrl(card.website_url)}` : '',
    card.profile_image_url ? `PHOTO;VALUE=URI:${safeExternalUrl(card.profile_image_url)}` : '',
    card.introduction ? `NOTE:${escapeVCard(card.introduction)}` : '',
    'END:VCARD',
  ].filter(Boolean)

  const blob = new Blob([lines.join('\r\n')], { type: 'text/vcard;charset=utf-8' })
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = `${card.name.trim().replace(/\s+/g, '-') || 'sandhi-contact'}.vcf`
  link.click()
  URL.revokeObjectURL(link.href)
}
